import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import { Input, Table, Button, Divider } from 'antd';
import { NetworkDelaySearch, formatMoney, showErrorInNotification } from '../../../lib/util';
import ErrorWrapper from '../../../lib/error_wrapper';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Link } from 'react-router-dom';


const queryString = require('query-string');


const group_schema = [
  {
    index: "name",
    name: "Name",
    type: 'text',
    // help_text:"Hello i am help text"
  }, {
    index: 'description',
    name: "Description",
    type: 'textarea'
  },
]
const group_cols = ({ onEditPressed}) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    className: 'word-break bold-cell'
  }, {
    title: "Description",
    dataIndex: "description",
    key: 'description'
  },
  {
    title:"Datatypes",
    dataIndex:'data_type_count',
    key:'data_type_count',
    className:'right-align',
    width:50,
    render:(value,data)=>{
      return <Link to={`/settings/groups/${data.id}/datatype`}>
      {formatMoney(value,0)}</Link>
    }
  },
  {
    title:"Reconcilers",
    dataIndex:'reconciler_count',
    key:'reconciler_count',
    className:'right-align',
    width:50,
    render:(value,data)=>{
      return <Link to={`/settings/groups/${data.id}/reconcilers`}>
      {formatMoney(value,0)}</Link>
    }
  },
  {
    title:"Sources",
    dataIndex:'source_count',
    key:'source_count',
    className:'right-align',
    width:50,
    render:(value,data)=>{
      return <Link to={`/settings/groups/${data.id}/source`}>
      {formatMoney(value,0)}</Link>
    }
  },
  {
    title:"Source Labels",
    dataIndex:'label_count',
    key:'label_count',
    className:'right-align',
    width:120,
    render:(value,data)=>{
      return <Link to={`/settings/groups/${data.id}/labels`}>
      {formatMoney(value,0)}</Link>
    }
  },
  {
    title: "Actions",
    dataIndex: 'id',
    key: 'action',
    className:'center-align',
    width: 100,
    render: (id, data) => {
        return <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent:'center'
        }}>
            <Button
                type='link'
                style={{ padding: 0 }}
                onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(id, data);
                }}>Edit</Button>
                 {/* <Divider type='vertical' />
                <Link to={`/settings/groups/${id}/datatype`}>
                    <Button style={{ padding: 0 }} type='link'>Datatypes</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/${id}/reconcilers`}>
                    <Button style={{ padding: 0 }} type='link'>Reconcilers</Button>
                </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/${id}/source`}>
                    <Button style={{ padding: 0 }} type='link'>Sources</Button>
                </Link> */}
                {/* <Divider type='vertical' />
                <Link to={`/settings/groups/${id}/labels`}>
                    <Button style={{ padding: 0 }} type='link'>Labels</Button>
                </Link> */}
        </div>
    }
}
]
class GroupList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query: {
        per_page: 10,
        page: 1
      },
      form_data: {},
      edit_id: null,
      form_visibility: false,
      selected_ids: [],
    };
    this.list_groups = RESTExecutor.list().config({
      label: 'list'
    }).connect(props.domains.groups);

    this.post_groups= RESTExecutor.post().config({
      label: 'list'
    }).callbacks((success)=>{
        this.setState({
          form_visibility:false,
          form_data:{},
          edit_id:null
        });
        this.list_groups.execute(); 
    }).connect(props.domains.groups);

    this.patch_groups= RESTExecutor.patch().config({
      label: 'detail'
    }).callbacks((success)=>{
        this.setState({
          form_visibility:false,
          form_data:{},
          edit_id:null
        });
        this.list_groups.execute(); 
    }).connect(props.domains.groups);

    this.export_data = RESTExecutor.post().config({
      label: 'export'
  }).callbacks((success) => {
      this.setState({ selected_ids: [] })
      // console.log("download url",success)
      window.open(success.result.url, '_blank');

  }, (error) => {
      showErrorInNotification(error)
  }).connect(props.domains.settings);


    this.delay_search = new NetworkDelaySearch();

  }


  handlePostPatch = (data) => {

    if (this.state.edit_id) {
      this.patch_groups.forId(this.state.edit_id).execute(data);
    } else {
      this.post_groups.execute(data);
    }
  }

  stateUpdater = ({
    stateKey,
    valueKey,
    value,
    appendObj = {},
    callback
  }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }
  render() {
    let list_groups_resp = this.list_groups.response();
    let post_groups_resp=this.post_groups.response();
    let  patch_groups_resp=this.patch_groups.response()
    let export_data_resp = this.export_data.response();

    let rowsData = (list_groups_resp.result && list_groups_resp.result.rows) || [];
    let rowsMeta = list_groups_resp.meta || {};
    const {selected_ids}=this.state;

    const {filter_query}=this.state;
    return (
      <div>
        <BasicHeader no_back title="Groups"
          menu_items={[]}
          right={[
            <TransparentButton
              label="Add New"
              className='cta-primary'
              hint="Add New Group"
              onClick={() => {
                this.setState({
                  edit_id: null,
                  form_data: {},
                  form_visibility: true
                })
              }}

            />,
            <TransparentButton
            label="Export"
            hint="Export Selected Groups"
            disabled={selected_ids.length == 0}
            onClick={() => {
                this.export_data.execute({
                    groups:selected_ids
                });
            }}

        />
          ]}
        />
         <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',

                    }}>
                        <Input.Search
                            autoFocus
                            placeholder="Search For"
                            style={{
                            }}
                            value={filter_query.query}
                            onChange={(e) => {
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {

                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })
                                    }
                                })
                            }}
                        />
                    </div>
                    </div>

                    <PopUpForm
                        title={"Group"}
                        forCreate={this.state.edit_id
                            ? false
                            : true}
                        initialData={this.state.form_data}
                        fields={group_schema}
                        open={this.state.form_visibility}
                        networkState={this.state.edit_id
                            ? patch_groups_resp
                            : post_groups_resp}
                        onClose={() => this.setState({ form_visibility: false })}
                        onSubmit={(data) => {
                            console.log("DATA", data);
                            this.handlePostPatch(data);
                        }} />

                    <ErrorWrapper
                error={list_groups_resp}
                onReload={()=>{
                    this.list_groups.execute()
                }}
                >
                
                <div
                    className='default-card'
                    style={{
                        padding: 0
                    }}>
                        <Table // rowClassName='hand-cursor'
                        className='main-table'
                        loading={list_groups_resp.fetching}
                        rowSelection={{
                          onChange: (selected_ids) => {
                              this.setState({ selected_ids })
                          },
                          selectedRowKeys: selected_ids
                      }}
                        size='small'
                        scroll={{ x: true }}
                        pagination={{
                            simple: false,
                            position: 'bottom',
                            onChange: (current, size) => {
                                this.props.history.push({
                                    search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                })
                            },
                            defaultCurrent: 1,
                            current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                            pageSize: (rowsMeta && rowsMeta.requested_count),
                            total: (rowsMeta && rowsMeta.total_count),
                            showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                        rowKey={(record) => record.id} columns={group_cols({
                            onEditPressed: (id, data) => {
                                this.setState({
                                    edit_id: id,
                                    form_data: data,
                                    form_visibility: true
                                })

                            }
                        })} dataSource={rowsData} />
                      
                      </div></ErrorWrapper>
        </div>
    );
  }
  componentDidMount() {
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query = parsed;
    }
    this.setState({
        filter_query: {
            per_page: 100,
            page: 1,
            ...new_filter_query
        }
    }, () => {
        this.list_groups.config({
            params: {
                ...this.state.filter_query
            }
        }).execute()
    })
  }

  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if ((this.props.location.search !== nextProps.location.search)) {
        const parsed = queryString.parse(nextProps.location.search);
        new_filter_query = parsed;
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            },
            selected_ids:[]
        }, () => {
            this.list_groups.config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()
        })
    } 

}
}

export default withDomains(GroupList, "groups","settings");
